// extracted by mini-css-extract-plugin
module.exports = {"rssIcon":"Rss_rssIcon__mn0w8"};